export default {"src":"/_next/static/media/verifyCheck.28ff27c7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};